/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useCallback, useEffect, useState } from 'react'
import {
  Loading,
  usePermissions,
  SimpleForm /* , useGetList */,
  useStore,
} from 'react-admin'
// import WidgetDashboard from './WidgetDashboard'
import Container from '@mui/material/Container'
import { Grid } from '@mui/material'
import DatePeriodInputs from './DatePeriodInputs'
import FilterButton from './FilterButton'
import Transaction from '../../components/icons/Transaction'
import Confirm from '../../components/icons/Confirm'
import Pending from '../../components/icons/Pending'
import Cancel from '../../components/icons/Cancel'
import Complete from '../../components/icons/Complete'
import Temp from '../../components/icons/Temp'
import dayjs from 'dayjs'

import ManageSearchRoundedIcon from '@mui/icons-material/ManageSearchRounded'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import CleanButton from './CleanButton'
import CardCustom from './CardCustom'
import axios from '../../config/connections'
import _ from 'lodash'
import { BranchSelect } from '../../components/app-bar/type'

const Dashboard: React.FC = () => {
  const { /* permissions,*/ isLoading } = usePermissions()
  const [dateJS, setDateJS] = useState({
    start_date: dayjs().startOf('day'),
    end_date: dayjs().endOf('day'),
  })
  const [date, setDate] = useState({
    start_date: dayjs().startOf('day').toISOString(),
    end_date: dayjs().endOf('day').toISOString(),
  })

  const [globalBranch] = useStore<BranchSelect>('branch.selected')

  const [listDashboard, setListDashboard] = useState(null)
  useEffect(() => {
    setListDashboard(listDashboard)
  }, [listDashboard, date, globalBranch?.id])
  
  const fetchData = useCallback(async (startDate, endDate, branchCode): Promise<void> => {
    const res = await axios.get('dashboards', {
      params: {
        start_date: startDate,
        end_date: endDate,
        branch_code: branchCode,
      },
    })
    const result = _.get(res, 'data.result')
    setListDashboard(result)
    setDate({ start_date: startDate, end_date: endDate })
    globalBranch?.id
  },[globalBranch?.id])

  useEffect(() => {
    fetchData(date.start_date, date.end_date, globalBranch?.id)
  },[date.end_date, date.start_date, fetchData, globalBranch?.id])

  useEffect(() => {
    setDate({
      start_date: dayjs().startOf('day').toISOString(),
      end_date: dayjs().endOf('day').toISOString(),
    }),
      fetchData(
        dayjs().startOf('day').toISOString(),
        dayjs().endOf('day').toISOString(),
        globalBranch?.id,
      )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isLoading) {
    return <Loading />
  }

  
  // const pe rmissionNews = permissions.find((permission) => permission.key == 'news_management')
  const onClickFilter = (data): void => {
    // console.log('🚀 ~ file: index.tsx:68 ~ onClickFilter ~ data:', data)
    fetchData(data.start_date.toISOString(), data.end_date.toISOString(), globalBranch?.id)
  }
  function onClickClean(): void {
    const tempDayJs = dayjs()
    setDateJS({ start_date: tempDayJs.startOf('day'), end_date: tempDayJs.endOf('day') })
    fetchData(
      tempDayJs.startOf('day').toISOString(),
      tempDayJs.endOf('day').toISOString(),
      globalBranch?.id,
    )
  }
  return (
    <Container maxWidth='xl' sx={{ pt: '60px' }}>
      <SimpleForm onSubmit={onClickFilter} toolbar={false}>
        <Grid container spacing={2}>
          <DatePeriodInputs startDate={dateJS.start_date} endDate={dateJS.end_date} />

          <Grid item xs={6} md={2}>
            <FilterButton label={'ค้นหา'} Icon={ManageSearchRoundedIcon} />
          </Grid>
          <Grid item xs={6} md={2}>
            <CleanButton label={'รีเซ็ตวันที่'} Icon={DeleteOutlineRoundedIcon} onClick={onClickClean} />
          </Grid>
        </Grid>
      </SimpleForm>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4}>
          <CardCustom
            total={listDashboard?.all || 0}
            Icon={Transaction}
            title='จองทั้งหมด'
            color='secondary'
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <CardCustom
            total={listDashboard?.pending || 0}
            Icon={Pending}
            title='รอดำเนินการ'
            color='secondary'
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <CardCustom
            total={listDashboard?.temporary || 0}
            Icon={Temp}
            title='ขอคิวสำรอง'
            color='secondary'
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <CardCustom
            total={listDashboard?.confirm || 0}
            Icon={Confirm}
            title='รายการนัด'
            color='secondary'
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <CardCustom
            total={listDashboard?.cancel || 0}
            Icon={Cancel}
            title='ยกเลิก'
            color='secondary'
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <CardCustom
            total={listDashboard?.complete || 0}
            Icon={Complete}
            title='เสร็จสิ้น'
            color='secondary'
          />
        </Grid>
      </Grid>
    </Container>
  )
}

export default Dashboard
